import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook that scrolls to top on route changes and disables scroll restoration
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser scroll restoration
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Scroll to top immediately on route change
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollToTop;
